<template>
  <div class="commission-setting">
    <el-card>
      <div slot="header">
        <span>分成设置</span>
        <el-button type="primary" size="small" style="float:right;margin-left:10px" @click="openBatch">批量设置</el-button>
        <el-button type="success" size="small" style="float:right" @click="showDialog = true">单条新增</el-button>
      </div>

      <el-table :data="commissionList" border stripe v-loading="loading">
        <el-table-column prop="targetUserNickname" label="下级用户" width="130"></el-table-column>
        <el-table-column prop="targetUserName" label="用户名" width="120"></el-table-column>
        <el-table-column prop="videoId" label="视频号ID" width="170" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.videoId || '全部' }}
          </template>
        </el-table-column>
        <el-table-column prop="commissionRate" label="分成比例(%)" width="130">
          <template slot-scope="scope">
            <el-tag type="success">{{ scope.row.commissionRate }}%</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="170"></el-table-column>
        <el-table-column label="操作" width="120">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button type="text" size="small" style="color:#f56c6c" @click="handleDelete(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-dialog :title="editingId ? '编辑分成' : '新增分成'" :visible.sync="showDialog" width="450px">
      <el-form ref="form" :model="form" :rules="rules" label-width="120px">
        <el-form-item label="下级用户" prop="targetUserId" v-if="!editingId">
          <el-select v-model="form.targetUserId" filterable placeholder="请选择" style="width:100%">
            <el-option v-for="u in subUsers" :key="u.id" :label="u.nickname + '(' + u.username + ')'" :value="u.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="视频号ID">
          <el-input v-model="form.videoId" placeholder="留空=全部视频号"></el-input>
        </el-form-item>
        <el-form-item label="分成比例(%)" prop="commissionRate">
          <el-input-number v-model="form.commissionRate" :min="0" :max="100" :precision="2" style="width:100%"></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="showDialog = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit">确认</el-button>
      </div>
    </el-dialog>

    <el-dialog title="批量设置分成" :visible.sync="showBatch" width="550px">
      <el-radio-group v-model="batchMode" size="small" style="margin-bottom:15px">
        <el-radio-button label="user">按用户</el-radio-button>
        <el-radio-button label="role">按角色</el-radio-button>
        <el-radio-button label="group">按分组</el-radio-button>
      </el-radio-group>
      <el-form v-if="batchMode==='user'" ref="batchForm" :model="batchForm" :rules="batchRules" label-width="120px">
        <el-form-item label="下级用户" prop="targetUserIds">
          <el-select v-model="batchForm.targetUserIds" multiple filterable placeholder="选择多个下级用户" style="width:100%">
            <el-option v-for="u in subUsers" :key="u.id" :label="u.nickname + '(' + u.username + ')'" :value="u.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="视频号ID">
          <el-input v-model="batchForm.videoId" placeholder="留空=全部视频号"></el-input>
        </el-form-item>
        <el-form-item label="分成比例(%)" prop="commissionRate">
          <el-input-number v-model="batchForm.commissionRate" :min="0" :max="100" :precision="2" style="width:100%"></el-input-number>
        </el-form-item>
      </el-form>
      <el-form v-else-if="batchMode==='role'" ref="batchRoleForm" :model="batchRoleForm" :rules="batchRoleRules" label-width="120px">
        <el-form-item label="选择角色" prop="roleType">
          <el-select v-model="batchRoleForm.roleType" filterable placeholder="选择角色" style="width:100%">
            <el-option label="子管理员 (SUB_ADMIN)" value="SUB_ADMIN"></el-option>
            <el-option label="普通用户 (USER)" value="USER"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="覆盖用户">
          <el-tag type="info" size="small">将应用到所有该角色的直属下级（共 {{ batchRoleForm.previewUserCount }} 人）</el-tag>
        </el-form-item>
        <el-form-item label="视频号ID">
          <el-input v-model="batchRoleForm.videoId" placeholder="留空=全部视频号"></el-input>
        </el-form-item>
        <el-form-item label="分成比例(%)" prop="commissionRate">
          <el-input-number v-model="batchRoleForm.commissionRate" :min="0" :max="100" :precision="2" style="width:100%"></el-input-number>
        </el-form-item>
      </el-form>
      <el-form v-else ref="batchGroupForm" :model="batchGroupForm" :rules="batchGroupRules" label-width="120px">
        <el-form-item label="选择分组" prop="groupId">
          <el-select v-model="batchGroupForm.groupId" filterable placeholder="选择分组" style="width:100%" @change="onGroupChange">
            <el-option v-for="g in groupList" :key="g.id" :label="g.groupName + ' (' + (g.videoIds||[]).length + '个视频号)'" :value="g.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="覆盖视频号">
          <div style="color:#606266">{{ batchGroupForm.previewVideoIds.length }} 个视频号</div>
          <div style="color:#909399;font-size:12px;margin-top:2px">{{ batchGroupForm.previewVideoIds.slice(0,10).join(', ') }}{{ batchGroupForm.previewVideoIds.length>10?'...':'' }}</div>
        </el-form-item>
        <el-form-item label="下级用户">
          <el-tag type="info" size="small">自动应用到所有直属下级（共 {{ subUsers.length }} 人）</el-tag>
        </el-form-item>
        <el-form-item label="分成比例(%)" prop="commissionRate">
          <el-input-number v-model="batchGroupForm.commissionRate" :min="0" :max="100" :precision="2" style="width:100%"></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="showBatch = false">取消</el-button>
        <el-button type="primary" @click="handleBatchSubmit">确认批量设置</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from '@/api'
export default {
  name: 'CommissionSetting',
  data() {
    return {
      commissionList: [],
      subUsers: [],
      groupList: [],
      loading: false,
      showDialog: false,
      showBatch: false,
      batchMode: 'user',
      editingId: null,
      form: { targetUserId: null, videoId: '', commissionRate: 0 },
      rules: {
        targetUserId: [{ required: true, message: '请选择下级用户', trigger: 'change' }],
        commissionRate: [{ required: true, message: '请输入分成比例', trigger: 'blur' }]
      },
      batchForm: { targetUserIds: [], videoId: '', commissionRate: 0 },
      batchRules: {
        targetUserIds: [{ type: 'array', required: true, message: '请选择下级用户', trigger: 'change' }],
        commissionRate: [{ required: true, message: '请输入分成比例', trigger: 'blur' }]
      },
      batchGroupForm: { groupId: null, commissionRate: 0, previewVideoIds: [] },
      batchGroupRules: {
        groupId: [{ required: true, message: '请选择分组', trigger: 'change' }],
        commissionRate: [{ required: true, message: '请输入分成比例', trigger: 'blur' }]
      },
      batchRoleForm: { roleType: '', videoId: '', commissionRate: 0, previewUserCount: 0 },
      batchRoleRules: {
        roleType: [{ required: true, message: '请选择角色', trigger: 'change' }],
        commissionRate: [{ required: true, message: '请输入分成比例', trigger: 'blur' }]
      }
    }
  },
  computed: {
    roleFilteredUsers() {
      if (!this.batchRoleForm.roleType) return []
      return this.subUsers.filter(u => u.roleType === this.batchRoleForm.roleType)
    }
  },
  watch: {
    'batchRoleForm.roleType'(val) {
      this.batchRoleForm.previewUserCount = val ? this.roleFilteredUsers.length : 0
    }
  },
  mounted() {
    this.loadCommission()
    this.loadSubUsers()
    api.teamList().then(res => { this.groupList = res.data || [] })
  },
  methods: {
    loadCommission() {
      this.loading = true
      api.getCommissionList().then(res => {
        this.commissionList = res.data || []
      }).finally(() => { this.loading = false })
    },
    loadSubUsers() {
      api.getSubUsers().then(res => {
        this.subUsers = (res.data || []).filter(u => u.status === 1)
      })
    },
    openBatch() {
      this.batchMode = 'user'
      this.batchForm = { targetUserIds: [], videoId: '', commissionRate: 0 }
      this.batchGroupForm = { groupId: null, commissionRate: 0, previewVideoIds: [] }
      this.batchRoleForm = { roleType: '', videoId: '', commissionRate: 0, previewUserCount: 0 }
       this.showBatch = true
    },
    onGroupChange(groupId) {
      if (groupId) {
        const group = this.groupList.find(g => g.id === groupId)
        this.batchGroupForm.previewVideoIds = group ? (group.videoIds || []) : []
      } else {
        this.batchGroupForm.previewVideoIds = []
      }
    },
    handleEdit(row) {
      this.editingId = row.id
      this.form = { targetUserId: row.targetUserId, videoId: row.videoId || '', commissionRate: row.commissionRate }
      this.showDialog = true
    },
    handleSubmit() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        const payload = {
          targetUserId: this.form.targetUserId,
          videoId: this.form.videoId || null,
          commissionRate: this.form.commissionRate
        }
        api.setCommission(payload).then(() => {
          this.$message.success(this.editingId ? '修改成功' : '设置成功')
          this.showDialog = false
          this.editingId = null
          this.form = { targetUserId: null, videoId: '', commissionRate: 0 }
          this.loadCommission()
        })
      })
    },
    handleBatchSubmit() {
      if (this.batchMode === 'user') {
        this.$refs.batchForm.validate(valid => {
          if (!valid) return
          api.batchSetCommission({
            targetUserIds: this.batchForm.targetUserIds,
            videoId: this.batchForm.videoId || null,
            commissionRate: this.batchForm.commissionRate
          }).then(() => {
            this.$message.success('批量设置成功')
            this.showBatch = false
            this.loadCommission()
          })
        })
      } else if (this.batchMode === 'role') {
        this.$refs.batchRoleForm.validate(valid => {
          if (!valid) return
          api.batchSetCommission({
            roleType: this.batchRoleForm.roleType,
            videoId: this.batchRoleForm.videoId || null,
            commissionRate: this.batchRoleForm.commissionRate
          }).then(() => {
            this.$message.success('已应用到所有 ' + (this.batchRoleForm.roleType === 'SUB_ADMIN' ? '子管理员' : '普通用户') + '（共 ' + this.batchRoleForm.previewUserCount + ' 人）')
            this.showBatch = false
            this.loadCommission()
          })
        })
      } else {
         this.$refs.batchGroupForm.validate(valid => {
           if (!valid) return
           api.batchSetCommission({
             videoIds: this.batchGroupForm.previewVideoIds,
             commissionRate: this.batchGroupForm.commissionRate,
             applyToAllSubUsers: true
           }).then(() => {
             this.$message.success('已应用到所有直属下级（共 ' + this.subUsers.length + ' 人）')
             this.showBatch = false
             this.loadCommission()
           })
         })
       }
    },
    handleDelete(id) {
      this.$confirm('确认删除该分成设置?', '提示', { type: 'warning' }).then(() => {
        api.deleteCommission(id).then(() => {
          this.$message.success('删除成功')
          this.loadCommission()
        })
      })
    }
  }
}
</script>
